module.exports = __webpack_public_path__ + "templates.shopline_payment_v2_google_pay_button-b73c6230.html";